/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                             
*/
import { AssetConfigurationDTO } from '../../service/asset';
import { VisionApplication } from '../../application';
import { VisionWindowManager } from '../../window/manager';
import { VisionWindow } from '../../window/window';
import { VisionCameraTab } from '../camera_tab/camera';
import { CameraService } from './camera_service';
import { SVGIcons } from '../../map/svg';

export class CameraImageWindow extends VisionWindow {
    layout!: dhtmlXLayoutObject;
    grid!: dhtmlXGridObject;
    carousel!: dhtmlXCarousel;
    service: CameraService;
    parent: VisionCameraTab;
    assetConfig!: AssetConfigurationDTO | undefined;

    lastIcon: string | undefined = undefined;

    constructor(manager: VisionWindowManager, parent: VisionCameraTab) {
        super(manager, {
            id: 'camera_image_window',
            title: 'Photo',
            x: 30,
            y: 30,
            width: 700,
            height: 700,
        });
        this.window.setText('Camera Image');
        this.parent = parent;

        this.layout = this.window.attachLayout('2E');
        this.layout.cells('a').hideHeader();
        this.layout.cells('a').setWidth(640);
        this.layout.cells('a').setHeight(480);
        this.layout.cells('a').fixSize(true, true);
        this.layout.cells('b').collapse();
        this.layout.cells('b').setText('Details');

        this.grid = this.layout.cells('b').attachGrid();
        this.grid.setHeader('Field,Value', ',', []);
        this.grid.init();

        this.service = VisionApplication.getInstance().cameraService;
        this.carousel = this.layout.cells('a').attachCarousel();

        this.carousel.attachEvent('onSelect', (id) => {
            this.cellSelected(id);
        });

        this.window.attachEvent('onClose', (win) => {
            this.parent.cameraWindowOpen = false;
            this.clearLast();
            return true;
        });
    }

    private cellSelected(id: string): void {
        console.log('Cell was selected: ' + id);

        const request = this.service.cachedCameraData(id);
        this.carousel.cells(id).progressOn();
        request.then((data) => {
            let rotate = '';
            if (this.assetConfig) {
                if (this.assetConfig.cameraRotate == true) {
                    rotate = "style='transform: rotate(180deg);'";
                }
            }
            this.carousel.cells(id).attachHTMLString("<img src='data:image/jpg;base64," + data.imageBytes + "'" + rotate + '/>');
            this.grid.clearAll(false);
            this.grid.addRow('1', ['File Name', data.filename], 1, 0, '', false);
            this.grid.addRow('2', ['Location', data.latitude + ',' + data.longitude], 2, 0, '', false);
            this.grid.addRow('3', ['Timestamp', this.iowaTime(data.timestamp)], 3, 0, '', false);

            this.window.setText('Camera @ ' + this.iowaTime(data.timestamp));
            this.carousel.cells(id).progressOff();

            /*
            this.parent.cameraMarkerCache.get(id)?.setIcon({
                url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(SVGIcons.camera('red')),
                scaledSize: new google.maps.Size(32, 32), // Resize the SVG if needed
            });
            */
            this.highlight(this.parent.cameraMarkerCache.get(id));
            this.clearLast();

            this.lastIcon = id;

            const position = this.parent.cameraMarkerCache.get(id)?.position;
            if (position) {
                this.parent.cameraMap.map.map.panTo(position);
            }
        });
    }

    private highlight(mark: google.maps.marker.AdvancedMarkerElement | undefined) {
        if (mark != undefined) {
            this.parent.updateMarkerSvg(mark, SVGIcons.camera('red'));
        }
    }

    private clearLast() {
        if (this.lastIcon != undefined) {
            const mark = this.parent.cameraMarkerCache.get(this.lastIcon);
            if (mark != undefined) {
                this.parent.updateMarkerSvg(mark, SVGIcons.camera('black'));
            }
        }
    }

    public loadAsset(assetId: string) {
        /*
        const asset = VisionApplication.getInstance().latestService.assetCache.get(assetId);
        const assetConfig = VisionApplication.getInstance().assetService.assetList.get(assetId);

        if (asset) {
            const request = this.service.cachedCameraData(asset?.cameraImage);
            request.then((data) => {
                let rotate = '';
                if (assetConfig) {
                    if (assetConfig.config.cameraRotate == true) {
                        rotate = 'style="transform: rotate(180deg);"';
                    }
                }
                this.layout.cells('a').attachHTMLString("<img src='data:image/jpg;base64," + data.imageBytes + "' " + rotate + ' />');
                this.grid.addRow('1', ['File Name', data.filename], 1, 0, '', false);
                this.grid.addRow('2', ['Location', data.latitude + ',' + data.longitude], 2, 0, '', false);
                this.grid.addRow('3', ['Timestamp', this.iowaTime(data.timestamp)], 3, 0, '', false);
            });
        }
        */
    }

    private clearCarousel() {
        this.carousel.unload();
        this.carousel = this.layout.cells('a').attachCarousel();
        this.carousel.attachEvent('onSelect', (id) => {
            this.cellSelected(id);
        });
    }

    public loadImage(imgId: string, assetId: string) {
        this.clearLast(); // Clear out all marker colours
        this.clearCarousel();

        const asset = VisionApplication.getInstance().latestService.assetCache.get(assetId);
        const assetDTO = VisionApplication.getInstance().assetService.assetList.get(assetId);
        this.assetConfig = assetDTO?.config;

        const assetMarkers = this.parent.assetMarkerCache.get(assetId);

        let idx = 0;
        assetMarkers?.images.forEach((element) => {
            this.carousel.addCell(element.id, idx);
            console.log('Added Cell');
            idx += 1;
        });

        if (imgId != undefined) {
            this.cellSelected(imgId);
            this.carousel.cells(imgId).setActive();
        } else {
            const first = assetMarkers?.images.at(0)?.id;
            if (first != undefined) {
                this.cellSelected(first);
                this.carousel.cells(first).setActive();
            }
        }

        /*
        const request = this.service.cachedCameraData(imgId);
        request.then((data) => {
            let rotate = '';
            if (assetConfig) {
                if (assetConfig.config.cameraRotate == true) {
                    rotate = "style='transform: rotate(180deg);'";
                }
            }
            this.layout.cells('a').attachHTMLString("<img src='data:image/jpg;base64," + data.imageBytes + "'" + rotate + '/>');
            this.grid.addRow('1', ['File Name', data.filename], 1, 0, '', false);
            this.grid.addRow('2', ['Location', data.latitude + ',' + data.longitude], 2, 0, '', false);
            this.grid.addRow('3', ['Timestamp', this.iowaTime(data.timestamp)], 3, 0, '', false);

            this.window.setText('Camera @ ' + this.iowaTime(data.timestamp));
        });
        */
    }

    private iowaTime(timestamp: string | number) {
        const date = new Date(timestamp);

        const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: 'America/Chicago',
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: false,
        });
        const parts = formatter.formatToParts(date);
        const lookup: Record<string, string> = {};
        for (const part of parts) {
            if (part.type !== 'literal') {
                lookup[part.type] = part.value;
            }
        }

        return `${lookup.month}/${lookup.day}/${lookup.year} ${lookup.hour}:${lookup.minute}:${lookup.second}`;
    }
}
